export const validation = {
  validation: {
    duplicateName: 'Name already exists',
    maxLength: 'Maximum {{length}} characters',
    maxValue: 'Maximum {{length}}',
    multicast: 'Invalid multicast address',
    multicastOr0: 'Invalid multicast address or 0.0.0.0',
    ipv4: 'Invalid IPv4 unicast address',
    sourceAddressCannotBeMulticast: 'Source address cannot be multicast',

    port: 'Valid values (1 - 65535)',
    fileError: '{{filename}} is not a valid file',
    invalidCharacters: 'Contains invalid characters',
    invalidSubmit: 'Please correct the field marked in red below',
    invalidSubmit_plural: 'Please correct the fields marked in red below',
    nonAlphabetic: 'Contains non-alphabetic characters',
    number: 'Invalid number',
    outOfRange: 'Out of range',
    ValidBitRate: 'Valid bitrate ({{min}} - {{max}})',
    required: 'Required field',
    timezone: 'Invalid timezone',

    accounts: {
      passwordMustMatch: 'Passwords must match',
    },
    audioEncoder: {
      lang: 'Language code must be 3 characters',
    },
    dateTime: {
      ptp: {
        domainNumber: 'Valid values (0 - 127)',
        announcementTimeout: 'Valid values (2 - 10)',
      },
    },
    essence: {
      numOfChannels: 'Valid values (1 - 16)',
      rtpPayload: 'Valid values (0 - 127)',
    },
    metadata: {
      countryCodes: 'Limited to 6 countries',
      delta: 'Valid values (0 - 1000)',
    },
    network: {
      bandwidth: 'Invalid bandwidth',
      dns: 'Invalid DNS server address',
      domain: 'Invalid domain',
      ipOrHostname: 'Invalid IP address or hostname',
      ipv4: 'Invalid IPv4 address',
      ipv4DHCPMode: 'Invalid IPv4 DHCP mode',
      ipv6: 'Invalid IPv6 address',
      ipv6DHCPMode: 'Invalid IPv6 DHCP mode',
      ipv6PrefixLength: '1 - 128',
      netmask: 'Invalid netmask address',
      mDnsNameUnderscore: 'Contains _ character',
      mDnsNameSpace: 'Must not start or end with space',
    },
    policies: {
      autoLogoutTime: 'Valid values (1 - 1440)',
      digits: 'Valid values (0 - 40)',
      expirationDays: 'Valid values (1 - 180)',
      inactiveLockTime: 'Valid values (1 - 365)',
      limitPwdRetriesInterval: 'Valid values (5 - 60)',
      limitPwdRetriesMaxAttempts: 'Valid values (3 - 10)',
      minimumLifetime: 'Valid values (0 - 7)',
      minLen: 'Valid values (6 - 40)',
      rememberedPasswords: 'Valid values (5 - 500)',
      symbols: 'Valid values (0 - 40)',
      uppercase: 'Valid values (0 - 40)',
    },
    preview: { interval: 'Valid values (1 - 60)' },
    scte: {
      msgDeltaMs: 'Valid values (100 - 10000)',
      leapSeconds: 'Valid values (0 - 1000)',
    },
    service: {
      keepAliveNumber: 'Valid values (0 - 65535)',
    },
    stream: {
      noCommas: 'No commas',
      autoAssign: 'Must be empty, auto-assign or a number',
      encapsulation: '${path} is not a valid encapsulation type',
      fecMode: '${path} is not a valid FEC mode',
      srtMode: '${path} is not a valid SRT mode',
      portNumber: 'Valid values (1 - 65535)',
      portNumberRTP: 'Valid values (2 - 65534)',
      portNumberRTPError: 'RTP requires even port number',
      latencyNumber: 'Valid values (20 - 8000)',
      maxPassphraseLength: 'Valid values (10 - 79 characters)',
      overheadPercentageSrt: 'Valid values (5 - 50)',
      overheadPercentage: 'Valid values (5 - 100)',
      mtu: 'Valid values (268 - 1500)',
      ttl: 'Valid values (1 - 255)',
      tos: 'Valid values (0x00 - 0xFF)',
      rows: 'Valid values (4 - 20)',
      columnsA: 'Valid values (1 - 20)',
      columnsB: 'Valid values (4 - 20)',
      rowsColsMixed: 'Rows x Columns must be below 100',
      srtAccessUserName: '',
      srtAccessUserName2: '',
      srtAccessResourceName: '',
      audioPids: 'Valid values (16 - 8190)',
      videoPids: 'Valid values (16 - 8190)',
      metadataPids: 'Valid values (16 - 8190)',
      sctePids: 'Valid values (16 - 8190)',
      pcrPid: 'Valid values (16 - 8190)',
      pmtPid: 'Valid values (16 - 8190)',
      tsStreamId: 'Valid values (0 - 65535)',
      programNumber: 'Valid values (1 - 65535)',
    },
    videoEncoder: {
      bitrate: 'Valid bitrate (32 - 120000)',
      gopSize: 'Valid GOP size (1 - 1000)',
      sceneChangeThreshold: 'Valid threshold (1 - 100)',
    },
  },
};
